import { SelectableModel, SequenceKey, SocietyReference } from '@pwc/common';
import { DmsElement } from '../dms-element';

export class ConnectionEntry extends SelectableModel {
  elementId: number;
  element: DmsElement;
  fiscalYear?: number;
  fiscalYearId?: number;
}
